/**
 * @file Public landing page — pages/Landing/WhatWeDoPage.tsx.
 */

import React from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";
import "./ContentPage.css";

const WhatWeDoPage: React.FC = () => {
  return (
    <div className="landing-root">
      <header className="landing-header flex justify-center items-center space-x-3 text-center py-4">
        <h1 className="landing-main-title text-4xl font-bold text-primary">
          ICoMEC
        </h1>
        <h2 className="landing-sub-title text-xl text-grayDark">
          Indian Construction Materials Embodied Carbon Data Base
        </h2>
      </header>

      <nav className="landing-nav">
        <Link to="/">Home</Link>
        <Link to="/join">Join</Link>
        <Link to="/impact">Impact</Link>
        <Link to="/research">Research and Analysis</Link>
        <Link to="/about">About</Link>
      </nav>

      <section className="content-page">
        <h1 className="content-title">What We Do</h1>
        
        <div className="content-section">
          <h2>From Raw Data to Decision-Ready Insights</h2>
          <p>
            At ICoMEC, we engage in a continuous cycle of data curation and scientific analysis to support the construction industry's transition to a low-carbon future. Our work is organized into three pillars of action:
          </p>
          
          <h3>1. Data Curation & Quality Assurance</h3>
          <p>
            We systematically compile and curate embodied carbon data specifically for the Indian construction materials' context. Every data point undergoes a rigorous review process where we document data quality, ensuring that the information is traceable, verified, and grounded in real-world manufacturing conditions.
          </p>

          <h3>2. Advanced Statistical Analysis</h3>
          <p>
            Rather than providing a single, static figure, we analyze variability and uncertainty within the datasets. By quantifying the range of possible emissions, we provide a more honest and mathematically robust picture of a material's impact.
          </p>

          <h3>3. Benchmarking</h3>
          <p>
            We translate complex data into actionable knowledge by developing benchmarks and insights.
          </p>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="footer-main">
          <div className="footer-left">
            <h2>ICoMEC</h2>
            <p>
              Indian Construction Materials Embodied
              <br /> Carbon Data Base
            </p>
          </div>

          <div className="footer-links">
            <div>
              <h4>About Us</h4>
              <ul>
                <li><Link to="/who-we-are">Who We Are</Link></li>
                <li><Link to="/what-we-do">What We Do</Link></li>
                <li><Link to="/leadership">Leadership</Link></li>
                <li><Link to="/partners">Partners</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/glossary">Glossary</Link></li>
              </ul>
            </div>
            <div>
              <h4>Resources</h4>
              <ul>
                {/* <li><Link to="/resource-library">Resource Library</Link></li> */}
                <li><Link to="/events">Events</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <div className="footer-bottom">
        <p>
          <Link to="/cookies-policy">Cookies Policy</Link> · <Link to="/privacy-policy">Privacy Policy</Link> · <Link to="/legal">Legal</Link> · <Link to="/terms-of-use">Terms of Use</Link>
          {/* · <Link to="/imprint">Imprint</Link> */}
        </p>
        <p>© 2026 CARBSE. All rights reserved.</p>
      </div>
    </div>
  );
};

/** React component — What We Do Page. */
export default WhatWeDoPage;
